var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.18C2.5 19.83 4.67 22 8.31 22H16.68C20.32 22 22.49 19.83 22.49 16.19V7.81C22.5 4.17 20.33 2 16.69 2ZM12.5 15.88C10.36 15.88 8.62 14.14 8.62 12C8.62 9.86 10.36 8.12 12.5 8.12C14.64 8.12 16.38 9.86 16.38 12C16.38 14.14 14.64 15.88 12.5 15.88ZM18.42 6.88C18.37 7 18.3 7.11 18.21 7.21C18.11 7.3 18 7.37 17.88 7.42C17.76 7.47 17.63 7.5 17.5 7.5C17.23 7.5 16.98 7.4 16.79 7.21C16.7 7.11 16.63 7 16.58 6.88C16.53 6.76 16.5 6.63 16.5 6.5C16.5 6.37 16.53 6.24 16.58 6.12C16.63 5.99 16.7 5.89 16.79 5.79C17.02 5.56 17.37 5.45 17.69 5.52C17.76 5.53 17.82 5.55 17.88 5.58C17.94 5.6 18 5.63 18.06 5.67C18.11 5.7 18.16 5.75 18.21 5.79C18.3 5.89 18.37 5.99 18.42 6.12C18.47 6.24 18.5 6.37 18.5 6.5C18.5 6.63 18.47 6.76 18.42 6.88Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f38c94fd01d3bda7f7c454832f510b61.svg";
export { ForwardRef as ReactComponent };